import React from "react";
import "./index.scss";

const LoadingSpinner = () => {
  return <span className='loading-spinner'></span>;
};

export { LoadingSpinner };
